
import { newsPost } from '@/queries/news/newsPost.gql'
import ContentBuilder from '@/components/contentbuilder/ContentBuilder.vue'
import { formatMeta, getFormattedDate } from '~/utils'

export default {
  name: 'NewsPost',
  components: { ContentBuilder },
  filters: {
    removeTime(value) {
      return value.split(' ')?.[0].replace(/-/g, ' ') || value
    },
  },
  navigation: {
    disableTransparency: true,
  },
  async asyncData({ $queryPage, $config, $sentry, route, error }) {
    try {
      const { data } = await $queryPage(newsPost, {
        domainId: $config.domainId,
        pageId: route.meta[0].page_id,
      })

      if (!data.newsPost) {
        return error({ statusCode: 404, message: 'SERVER ERROR' })
      }

      return {
        newsPost: data.newsPost,
      }
    } catch (ex) {
      $sentry.captureException(ex)
      console.error('news/_slug error', ex.graphQLErrors)
    }
  },
  data() {
    return {
      pageContent: {},
      related: [],
      loading: 0,
      newsPost: null,
      externalNews: null,
    }
  },
  head() {
    if (!this.newsPost?.title) return {}
    const title = this.newsPost.title + ' | Teltonika'
    const url = `${this.$config.domain}${this.newsPost?.current_url?.full_url}`
    const socialImage =
      this.newsPost?.socialImages?.extras?.e_1200xAuto?.jpg?.src ||
      this.$config.domain + '/images/seo/teltonika_logo.jpg'

    return formatMeta({
      title,
      description: this.newsPost.metaDescription,
      img: socialImage,
      url,
      canonical: this.newsPost?.canonicalUrl || '',
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
    })
  },
  computed: {
    hashtags() {
      if (
        Array.isArray(this.newsPost?.hashTags) &&
        this.newsPost.hashTags.length
      ) {
        return '#' + this.newsPost.hashTags.join(', #')
      } else if (this.$config.isIot) {
        return '#iot'
      } else if (this.$config.isEms) {
        return '#ems'
      }
      return []
    },
    formattedDate() {
      return getFormattedDate(
        this.newsPost.date,
        this.$store.state['date-fns'].activeLocale,
        'MMMM d, y',
      )
    },
    article() {
      return this.newsPost?.content || false
    },
    relatedPosts() {
      return this.newsPost?.related_by_tags || []
    },
  },
}
